import { useRef, useEffect, useMemo } from "react";
import { Text, View, ScrollView, Pressable } from "react-native";
import { Link } from "expo-router";
import type { ResolvedTabChild } from "app/constants/tabConstants";

interface SubTabBarProps {
  subTabs: ResolvedTabChild[];
  currentPath: string;
}

export function SubTabBar({ subTabs, currentPath }: SubTabBarProps) {
  const scrollRef = useRef<ScrollView>(null);

  const activeIndex = useMemo(
    () => subTabs.findIndex((item) => currentPath.includes(item.path)),
    [subTabs, currentPath],
  );

  useEffect(() => {
    if (scrollRef.current && activeIndex >= 0) {
      const tabWidth = 120;
      const offset = activeIndex * tabWidth;
      scrollRef.current.scrollTo({ x: offset, animated: true });
    }
  }, [activeIndex]);

  return (
    <View className="border-b border-gray-200 bg-gray-50">
      <ScrollView
        ref={scrollRef}
        horizontal
        showsHorizontalScrollIndicator={false}
        scrollEventThrottle={16}
      >
        <View className="flex-row">
          {subTabs.map((item) => {
            const isActive = currentPath.includes(item.path);
            return (
              <Link href={item.path} key={item.path} asChild>
                <Pressable className="min-h-[48px] px-4 justify-center items-center">
                  <Text
                    className={`text-sm uppercase tracking-wide ${
                      isActive
                        ? "text-primary-600 font-semibold"
                        : "text-gray-500"
                    }`}
                  >
                    {item.label}
                  </Text>
                  {isActive && (
                    <View className="absolute bottom-0 left-0 right-0 h-0.5 bg-primary-600" />
                  )}
                </Pressable>
              </Link>
            );
          })}
        </View>
      </ScrollView>
    </View>
  );
}
